import ActivationTable from "../components/ActivationTable.svelte";
import {hydrate} from "svelte";


export default class AccountActivations {

    element: HTMLElement
    activations: ActivationsJson
    nonce: string
    subscription: string

    constructor(element: HTMLElement) {
        this.element = element;
        this.activations = this.mapActivations(JSON.parse(element.dataset.activations));
        this.nonce = element.dataset.nonce;
        this.subscription = element.dataset.subscription;
        this.init();
    }

    mapActivations(activations: ActivationsJson): ActivationsJson {
        return activations.map((activation: Activation) => {
            activation.checked = false;

            return activation;
        });
    }

    init() {
        hydrate(ActivationTable, {
            target: this.element,
            props: {
                activations: this.activations,
                nonce: this.nonce,
                subscription: this.subscription
            }
        });
    }

}